"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _combobox = require("@react-stately/combobox");
var _reactAria = require("react-aria");
var _InnerButton = require("../buttons/InnerButton");
var _ListBox = require("./supportcomponents/ListBox");
var _shared = require("./supportcomponents/shared");
var _Icon = require("../../media/icon/Icon");
var _input = require("../../inputs/input/input.tokens");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _globalTokens = require("../../../shared/global-tokens");
var _BaseButton = require("../buttons/BaseButton");
var _collections = require("@react-stately/collections");
var _ControlWrapper = require("../../../shared/aria-support-components/ControlWrapper.styled");
var _AriaPopover = require("../../../shared/aria-support-components/AriaPopover");
var _reactUse = require("react-use");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * ComboBox based on react-aria
 *
 * Based on this example: https://codesandbox.io/s/sharp-sun-e3fgd?file=/src/ListBox.tsx
 * Another example supporting groups of items: https://github.com/NadiaPosch/react-aria-dropdown/tree/main
 *
 * Would have liked to use radix, but they have not implemented combobox yet: https://github.com/radix-ui/primitives/issues/1342
 *
 * People recommend this combobox - but that would require pulling in another library: https://kobalte.dev/docs/core/components/combobox
 *
 * This should only be used when you need to be able to type in the input field and select from a list of options - otherwise a radix select probably provides more functionality out of the box.
 * */

var Input = _styledComponents.default.input.withConfig({
  displayName: "ComboBox__Input",
  componentId: "sc-1hzv2ln-0"
})(["appearance:none;padding:6px 8px;outline:none;border:none;background:none;margin:0;width:100%;", ";color:", ";height:", ";"], _tokens.default.sky.sys.font.body['1'], function (_ref) {
  var currentItemIsDisabled = _ref.currentItemIsDisabled;
  return currentItemIsDisabled ? _globalTokens.globalColor.text.semantic.error : _globalTokens.globalColor.text.content.main;
}, function (_ref2) {
  var sizeKey = _ref2.sizeKey;
  return _input.tokens.size.height[sizeKey];
});
/**
We prevent the escape press from bubbling up to the parent component, as it would otherwise close any modal.
We can add a prop to the component to allow the escape press to bubble up if needed
*/
var catchEscapePress = function catchEscapePress(e) {
  if (e.key === 'Escape') {
    e.preventDefault();
    e.stopPropagation();
  }
};
function ComboBox(_ref3) {
  var _ariaProps$disabledKe;
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? _input.TextFieldSize.LARGE : _ref3$size,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? _input.TextFieldWidth.FIXED : _ref3$width,
    label = _ref3.label,
    helperText = _ref3.helperText,
    errorText = _ref3.errorText,
    showErrorAsIconTooltip = _ref3.showErrorAsIconTooltip,
    value = _ref3.value,
    onChange = _ref3.onChange,
    disabled = _ref3.disabled,
    hasError = _ref3.hasError,
    dataCy = _ref3['data-cy'],
    ariaProps = _objectWithoutProperties(_ref3, ["size", "width", "label", "helperText", "errorText", "showErrorAsIconTooltip", "value", "onChange", "disabled", "hasError", 'data-cy']);
  var _ref4 = (0, _reactAria.useFilter)({
      sensitivity: 'base'
    }),
    contains = _ref4.contains;
  ariaProps.selectedKey = value;
  ariaProps.onSelectionChange = onChange;
  var state = (0, _combobox.useComboBoxState)(_objectSpread({}, ariaProps, {
    defaultFilter: contains
  }));
  var listState = state;
  var buttonRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var listBoxRef = React.useRef(null);
  var popoverRef = React.useRef(null);
  var _ref5 = (0, _reactUse.useMeasure)(),
    _ref6 = _slicedToArray(_ref5, 2),
    measureRef = _ref6[0],
    measurements = _ref6[1];
  var currentItemIsDisabled = (_ariaProps$disabledKe = ariaProps.disabledKeys) === null || _ariaProps$disabledKe === void 0 ? void 0 : _ariaProps$disabledKe.includes('' + listState.selectedKey);
  if (currentItemIsDisabled) {
    hasError = true;
  }
  var _ref7 = (0, _reactAria.useComboBox)(_objectSpread({
      label: label
    }, ariaProps, {
      inputRef: inputRef,
      buttonRef: buttonRef,
      listBoxRef: listBoxRef,
      popoverRef: popoverRef
    }), state),
    triggerProps = _ref7.buttonProps,
    inputProps = _ref7.inputProps,
    listBoxProps = _ref7.listBoxProps,
    labelProps = _ref7.labelProps;
  var _ref8 = (0, _reactAria.useButton)(triggerProps, buttonRef),
    buttonProps = _ref8.buttonProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoDisplayWrapper.InfoDisplayWrapper, {
    label: label,
    ariaLabelProps: labelProps,
    helperText: helperText,
    errorText: errorText,
    showErrorAsIconTooltip: showErrorAsIconTooltip,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      onKeyDown: catchEscapePress,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ControlWrapper.StyledControlWrapper, {
        height: size,
        width: width,
        isFocused: state.isFocused,
        ref: measureRef,
        disabled: disabled,
        hasError: hasError,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Input, _objectSpread({}, inputProps, {
          "data-cy": dataCy,
          "aria-label": label,
          ref: inputRef,
          isFocused: state.isFocused,
          sizeKey: size,
          disabled: disabled,
          currentItemIsDisabled: currentItemIsDisabled
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.LeftBorderWrapper, {
          size: size,
          hasError: hasError,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, buttonProps, {
            buttonRef: buttonRef,
            width: _input.tokens.size.height[size],
            height: '100%',
            hasError: hasError,
            emphasis: _BaseButton.EMPHASIS.MEDIUM,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'chevronDown'
            })
          }))
        })]
      }), state.isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AriaPopover.AriaPopover, {
        popoverRef: popoverRef,
        triggerRef: inputRef,
        state: state,
        isNonModal: true,
        offset: 4,
        placement: "bottom start",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.DropdownListWrapper, {
          width: measurements.width + 'px',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListBox.ListBox, _objectSpread({}, listBoxProps, {
            listBoxRef: listBoxRef,
            state: listState
          }))
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
    })
  });
}
ComboBox.Item = _collections.Item;
ComboBox.Section = _collections.Section;
ComboBox.WIDTH = _input.TextFieldWidth;
ComboBox.SIZE = _input.TextFieldSize;
var _default = exports.default = ComboBox;